import * as React from 'react';

import { InstallConfigService } from '../install/install-config.service';
import { LinkTarget } from '../shared/constants/link-target.enum';
import { OfficeRoute } from '../shared/constants/office-route.enum';
import { InstrumentationService, KnownInstrumentationEvents } from '../shared/instrumentation/instrumentation.service';
import { FileType } from '../shared/models/file-item.model';
import { LocService } from '../shared/shared-context/loc.service';
import { DimeExperience, UpsellDataService } from './upsell-data.service';

export interface UpsellButtonReactComponentProps {
    readonly locService: LocService;
    readonly installConfigService: InstallConfigService;
    readonly instrumentationService: InstrumentationService;
    readonly upsellDataService: UpsellDataService;
    readonly route: OfficeRoute;
    readonly app: FileType;
    readonly linkTarget: LinkTarget;
    readonly minimized: boolean;
}

export default !React
    ? () => null
    : class UpsellButtonComponent extends React.Component<UpsellButtonReactComponentProps> {
        constructor(props: UpsellButtonReactComponentProps) {
            super(props);
            this.launchDime = this.launchDime.bind(this);
        }

        public render() {
            if ((this.props.route !== OfficeRoute.Start && !(this.props.route === OfficeRoute.MyForms && this.props.app === FileType.Forms))
                || !(this.props.app === FileType.Word || this.props.app === FileType.Excel || this.props.app === FileType.PowerPoint || this.props.app === FileType.Forms || this.props.app === FileType.FormsQuiz)) {
                return null;
            }

            this.props.instrumentationService.logImpressionEvent(KnownInstrumentationEvents.UpsellButtonImpression);

            return (
                <a id='upsell-button'
                style={{ lineHeight: 'normal' }}
                className='shell-upsell-button o365sx-button o365sx-highContrastButton'
                href={this.getHref()}
                target={this.getTarget()}
                onClick={this.launchDime}
                aria-label={this.props.locService.FirstRunFreeConsumerGoPremium}>
                    <span className='shell-upsell-button__icon ms-ohp-Icon ms-ohp-Icon--diamond'></span>
                    {!this.props.minimized ? <span className='shell-upsell-button__text'>{this.props.locService.FirstRunFreeConsumerGoPremium}</span> : null}
                </a>
            );
        }

        private getHref(): string {
            return this.props.installConfigService.config.dimeEnabled ? 'javascript:void(0);' : this.getUrl();
        }

        private getTarget(): string {
            return this.props.installConfigService.config.dimeEnabled ? '' : this.props.linkTarget;
        }

        private getUrl(): string {
            const trackingParam = this.props.upsellDataService.getUpsellTrackingParam();
            return this.props.installConfigService.config.shellGoPremiumUrl.replace('{OEM}', trackingParam).replace('{APP}', FileType[this.props.app]);
        }

        private launchDime() {
            if (this.props.installConfigService.config.dimeEnabled) {
                this.props.upsellDataService.launchDime(DimeExperience.ShellGoPremiumButton, this.getUrl());
            }
        }
    };
